import React from "react"
import { useDispatch, useSelector } from "react-redux"

import update from "immutability-helper"
import { useDrag, useDrop } from "react-dnd"

import { masterSchemaSlice } from "@/slice/masterSchemaSlice"
import { RootState } from "@/store"
import { gqlClient } from "@/util/graphql"

// DnD 周りは以下を参考にした
// https://react-dnd.github.io/react-dnd/examples/sortable/simple
// https://tech.hey.jp/entry/2021/03/09/131638

type DropResult = { dropItemIndex: number }
export const DnDHeader = (props: {
	children: React.ReactNode
	headerIndex: number
	tableName: string
	defaultColor: string
	dropActiveColor: string
}) => {
	const { tableName, defaultColor, dropActiveColor } = props

	const dispatch = useDispatch()

	const columnNames = useSelector((state: RootState) => {
		const schema = state.masterSchema.data.find((data) => data.tableName == tableName)
		if (!schema) return []
		return schema.columns.map((c) => c.name)
	})

	const ref = React.useRef<HTMLDivElement>(null)

	const [{ isDragging }, drag] = useDrag({
		type: "DnDHeader",
		end: (_, monitor) => {
			const dropResult = monitor.getDropResult<DropResult>()
			if (dropResult) {
				const dragIndex = props.headerIndex
				const dropIndex = dropResult.dropItemIndex

				const newColumnNames = update(columnNames, {
					$splice: [
						[dragIndex, 1],
						[dropIndex, 0, columnNames[dragIndex]],
					],
				})

				const newVal = newColumnNames.map((name, sortIndex) => ({ name, sortIndex }))
				gqlClient()
					.updateMasterSchema({ tableName, columns: newVal })
					.then(({ updateMasterSchema: { result } }) => {
						if (result) {
							dispatch(masterSchemaSlice.actions.changeColumnOrder({ tableName, newColumnNames }))
						}
					})
			}
		},
		collect: (monitor) => {
			return { isDragging: monitor.isDragging() }
		},
	})
	const [{ isActive }, drop] = useDrop({
		accept: "DnDHeader",
		drop: () => ({
			dropItemIndex: props.headerIndex,
		}),
		collect: (monitor) => ({
			isActive: monitor.canDrop() && monitor.isOver(),
		}),
	})
	drag(drop(ref))

	const style = {
		cursor: "move",
		opacity: isDragging ? 0 : 1,
		color: isActive ? dropActiveColor : defaultColor,
	}

	return (
		<div ref={ref} style={style}>
			{props.children}
		</div>
	)
}
